export const FAQ = [
    {
        ques: "What is the main objective of the hackathon?",
        ans: "The main objective of the hackathon is to promote entrepreneurship and group working among students. Participants will collaborate in teams to develop innovative solutions to various problems."
    },
    {
        ques: "Who can participate in the hackathon?",
        ans: "The hackathon is open to all students from colleges situated in Delhi NCR. Participants must form teams with a maximum of four members, and all members must be from the same college."
    },
    {
        ques: "How many rounds are there in the hackathon?",
        ans: "The hackathon consists of three rounds: the Idea Proposal (First Round), the MVP Demo (Second Round), and the Finals (Third Round). The first and second rounds are conducted online, while the final round is held offline."
    },
    {
        ques: "What is required for the first round (Idea Proposal)?",
        ans: "In the first round, all teams must submit their idea related to the hackathon themes in the form of a PDF. The submission format is provided on the hackathon website. Teams will be judged on creativity, uniqueness, and usefulness of their idea."
    },
    {
        ques: "What happens in the second round (MVP Demo)?",
        ans: "Teams that advance to the second round must submit a demo of their project about 20 days after the first round. This includes uploading a video showing the clear working of their demo. Selected teams from this round will move to the finals."
    },
    {
        ques: "What is expected in the final round (Finals)?",
        ans: "In the final round, all finalist teams must implement their proposed idea in person. They will present their working model and give a detailed description of their project to a review committee of experienced judges. The codebase must be submitted in a .zip file on our platform."
    },
    {
        ques: "What is the team size requirement?",
        ans: "Each team can have a maximum of four participants. All team members must be from the same college."
    },
    {
        ques: "Is there a cost to participate?",
        ans: "Participation in the hackathon is free. However, any travel or accommodation expenses for the offline final round need to be covered by the participants."
    },
    {
        ques: "Will there be any prizes?",
        ans: "Yes, the winning team will receive prize money. The prize pool is yet to be decided."
    },
    {
        ques: "What is the timeline of the hackathon?",
        ans: "The hackathon will start on 30th June with the first round (Idea Proposal). The second round (MVP Demo) will take place about 20 days after the first round. The final round (Finals) will be held offline at a venue yet to be decided, approximately 20 days after the second round."
    },
    {
        ques: "What themes can we choose for our project?",
        ans: "The specific themes for the hackathon will be provided on the official hackathon website. Ensure your project aligns with one of these themes when submitting your idea."
    },
    {
        ques: "How will the projects be judged?",
        ans: "Projects will be judged based on creativity, uniqueness, usefulness, and implementation. The judging criteria may vary slightly for each round and will be detailed on the hackathon website."
    }
];
